"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMuiAccordion = exports.StyledAccordionSummary = exports.StyledAccordionDetails = void 0;
var _mui = require("@ori-ui/mui");
const StyledMuiAccordion = exports.StyledMuiAccordion = (0, _mui.styled)(_mui.Accordion)(({
  theme
}) => ({
  backgroundColor: theme.palette.grey[100],
  '&::before': {
    display: 'none'
  },
  [`&.${_mui.accordionClasses.expanded}`]: {
    margin: theme.spacing(0, 0, 3)
  }
}));
const StyledAccordionSummary = exports.StyledAccordionSummary = (0, _mui.styled)(_mui.AccordionSummary)(() => ({
  border: 'none',
  minHeight: '48px !important',
  padding: 0,
  [`& .${_mui.accordionSummaryClasses.content}`]: {
    margin: '0 !important',
    padding: 0
  }
}));
const StyledAccordionDetails = exports.StyledAccordionDetails = (0, _mui.styled)(_mui.AccordionDetails)(() => ({
  padding: 0
}));